import { personNameFrag } from "packages/client/src/app/services/types/person.types";
import { userInfoFrag } from "packages/client/src/app/utils/type/user.common-type";

export const getWarehouseMaterialOperationsFrag = `
    id
    warehouseMaterialId
    type
    amount
    date
    description
    folderId
    folder {
        id
        person {
            ${personNameFrag}
        }
    }
    workerIds
    workers {
        ${userInfoFrag}
    }
`
